import { Box, useMediaQuery, useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SectionContent from "../component-parts/walccare/SectionContent";
import Contact from "../component-parts/walccare/Contact";
import CustomerValue from "../component-parts/walccare/CustomerValue";
import ScrollTab from "../component-parts/walccare/ScrollTab";
import Vision from "../component-parts/walccare/Vision";
import WalcCareTheme from "./WalcCareTheme";

export default function WalcCare({ setPage }) {
    const walccareTheme = WalcCareTheme();
    const theme = useTheme();
    const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation("conditionagent");

    React.useEffect(() => {
        setPage("walccare");
    }, [setPage]);

    const [activeTab, setActiveTab] = useState(0);

    // 動的にセクション設定を生成
    const sectionConfigs = [
        {
            key: "scan",
            id: "scan",
            padding: "119px 0px 100px 0px",
            paddingMobile: "46px",
            paddingBottom: "0px",
        },
        {
            key: "collectAndDiagnose",
            id: "collecAndDiagnose",
            padding: "105.5px 0px 100px 0px",
            paddingMobile: "46px",
            paddingBottom: "0px",
        },
        {
            key: "reportAndCare",
            id: "reportAndCare",
            padding: "99.1px 0px 231px 0px",
            paddingMobile: "46px",
            paddingBottom: "100px",
        },
    ];

    // タブの設定を動的に生成
    const tabContents = sectionConfigs.map((config, index) => {
        const sectionData = t(config.key, { returnObjects: true }) as any;
        const titleParts = sectionData.title ? sectionData.title.split(" ") : [`0${index + 1}`, "Unknown"];

        return {
            tabLabelNumber: titleParts[0],
            tabLabelTitle: titleParts.slice(1).join(" "),
            id: config.id,
        };
    });

    const handleTabChange = (tabIndex: number) => {
        setActiveTab(tabIndex);

        const contentId = tabContents[tabIndex].id;
        const element = document.getElementById(contentId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: "-50% 0% -50% 0%",
            threshold: 0.0,
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const contentId = entry.target.id;
                    const tabIndex = tabContents.findIndex((tab) => tab.id === contentId);
                    if (tabIndex !== -1) {
                        setActiveTab(tabIndex);
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        tabContents.forEach((tab) => {
            const contentElement = document.getElementById(tab.id);
            if (contentElement) {
                observer.observe(contentElement);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, [tabContents]);

    return (
        <React.Fragment>
            <ThemeProvider theme={walccareTheme()}>
                <Vision />
                <CustomerValue />
                {isDownSm ? (
                    <React.Fragment>
                        <ScrollTab tabContents={tabContents} handleTabChange={handleTabChange} activeTab={activeTab} />
                        {sectionConfigs.map((config, index) => (
                            <Box
                                key={config.key}
                                id={config.id}
                                sx={{
                                    paddingTop: "50px",
                                }}
                            >
                                <SectionContent
                                    sectionKey={config.key}
                                    basePadding={config.padding}
                                    basePaddingMobile={config.paddingMobile}
                                    basePaddingBottom={config.paddingBottom}
                                />
                            </Box>
                        ))}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {sectionConfigs.map((config, index) => (
                            <Box key={config.key} id={config.id}>
                                <ScrollTab
                                    tabContents={tabContents}
                                    handleTabChange={handleTabChange}
                                    activeTab={activeTab}
                                />
                                <SectionContent
                                    sectionKey={config.key}
                                    basePadding={config.padding}
                                    basePaddingMobile={config.paddingMobile}
                                    basePaddingBottom={config.paddingBottom}
                                />
                            </Box>
                        ))}
                    </React.Fragment>
                )}
                <Contact />
            </ThemeProvider>
        </React.Fragment>
    );
}
